export default "__VITE_ASSET__cf0cf14e__"